import { useAppSelector } from "../redux/hooks";
import { userSliceSelector } from "../features/userSlice";

export const useCapabilities = (checkCapabilities?: string[]) => {
    const {Capabilities} = useAppSelector(userSliceSelector);

    let capabilities: Record<string, boolean> = {};

    if (checkCapabilities?.length && Capabilities?.length) {
        capabilities = Object.fromEntries(
            checkCapabilities.map((capability) => [capability, Capabilities.includes(capability)]),
        );
    }

    return { capabilities };
}
